var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlertOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20h-.353c-.616 0-1.136-.269-1.425-.737-.289-.468-.297-1.053-.022-1.605l2.931-5.153a1.001 1.001 0 011.738.99l-2.587 4.546A1 1 0 014 20M6 8a1 1 0 01-1-1c0-3.86 3.139-7 6.998-7a7.005 7.005 0 016.772 5.213 1.001 1.001 0 01-1.935.509A5 5 0 007 7a1 1 0 01-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.916 7a1 1 0 01-.985-.834 4.757 4.757 0 00-.096-.445 1.001 1.001 0 011.935-.507c.053.203.098.41.133.62A1 1 0 0117.916 7M6 14a1 1 0 01-1-1V7a1 1 0 012 0v6a1 1 0 01-1 1M18 14a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 24a.999.999 0 01-.707-1.707l22-22a.999.999 0 111.414 1.414l-22 22A.997.997 0 011 24M18.866 12.506l2.906 5.106c.3.598.293 1.183.003 1.652-.29.468-.808.737-1.425.737h-4.353c0 2.205-1.795 4-4.002 4a4.001 4.001 0 01-3.993-3.771.997.997 0 01.237-.705l.997-1.172a.997.997 0 01.76-.352h9.697l-2.565-4.506a1 1 0 011.738-.99zM13.996 20H10.46l-.407.478A2.002 2.002 0 0013.997 20z"
  }))));
}

export default SvgIconAlertOff;